import { Fragment, useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../../Context/AuthContext";
import { ConvertToFloat } from "../../../Layout/Common/common";

export const QuickOrderOrderDetails = () => {
  const globalcontext = useContext(GlobalContext);
  const [CartItem, setCartItem] = useState(null);
  const location = useLocation();
  useEffect(() => {
    setCartItem(globalcontext.CartItem);
  }, [globalcontext.CartItem]);

  return (
    <div className="col-lg-12">
      <h3 className="quickOrder-title">Order Summary</h3>
      <div className="order-summary-details mb-4">
        <div className="order-prices quickOrder-price">
          <div className="order-prices-list">
            <p>Sub Total</p>
            <span> $ {CartItem ? ConvertToFloat(CartItem.totalcost ?? 0) : 0}</span>
          </div>
          <div className="order-prices-list">
            <p>Tax Amount</p>
            <span>$ {CartItem ? ConvertToFloat(CartItem.totaltax ?? 0) : 0}</span>
          </div>
          <div className="order-prices-list">
            <p>Freight</p>
            <span>TBA</span>
          </div>
        </div>

        <div className="order-prices-list order-prices-total">
          <p>Total</p>
          <span> $ {CartItem ? ConvertToFloat(CartItem.totalIncTax ?? 0) : 0}</span>
        </div>
      </div>
    </div>
  );
};
